import { render, staticRenderFns } from "./lot-unit-edit-form.html?vue&type=template&id=385eeb5a&scoped=true&"
import script from "./lot-unit-edit-form.ts?vue&type=script&lang=js&"
export * from "./lot-unit-edit-form.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385eeb5a",
  null
  
)

export default component.exports